import { coreSonarObjectsOptimisticChangeAddSlice } from '../optimistic/add';
import { createPatchAsyncSlice } from '@sonar-software/xuder';
import { patchSalesforceSonarObjectsBulk } from '@api';

export const getCoreSonarObjectsBulkPatchAsyncSlice = createPatchAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			({ sonarObjectIds, ...salesforce }) => coreSonarObjectsOptimisticChangeAddSlice.syncActionCreator({
				salesforce: {
					...salesforce.complianceCategory ?
						{ complianceCategory: salesforce.complianceCategory } : {},
					...salesforce.dataSensitivityLevelId ?
						{ dataSensitivityLevelId: salesforce.dataSensitivityLevelId } : {},
					...salesforce.fieldUsageId ?
						{ fieldUsageId: salesforce.fieldUsageId } : {}
				},
				sonarObjectIds
			})
		]
	},
	name: 'CoreSonarObjectsBulkPatch',
	receive: true,
	request: true,
	requestHandler: patchSalesforceSonarObjectsBulk
});
